import dayjs from '@/utils/dayjs'

export function maskPhone(value?: string | null) {
  const phone = String(value || '').trim()
  if (phone.length < 7) {
    return phone ? `${phone.slice(0, 2)}***` : '未绑定'
  }
  return `${phone.slice(0, 3)}****${phone.slice(-4)}`
}

export function maskEmail(value?: string | null) {
  const email = String(value || '').trim()
  if (!email.includes('@')) {
    return email ? '***' : '未绑定'
  }
  const [local, domain] = email.split('@')
  return `${local.slice(0, 1)}***@${domain}`
}

export function maskName(value?: string | null) {
  const name = String(value || '').trim()
  if (!name) {
    return '未实名'
  }
  return name.length === 1 ? '*' : `${name.slice(0, 1)}${'*'.repeat(Math.min(2, name.length - 1))}`
}

export function maskAddress(...parts: Array<string | null | undefined>) {
  const normalized = parts.map(item => String(item || '').trim()).filter(Boolean)
  if (!normalized.length) {
    return '未填写'
  }
  return `${normalized.slice(0, 2).join(' ')} ***`
}

export function formatDateTime(value?: string | null, fallback = '-') {
  return value ? dayjs(value).format('YYYY-MM-DD HH:mm') : fallback
}

export function profileCompleteness(user: {
  avatar?: string | null
  birthday?: string | null
  gender?: number
  interest_tags?: readonly string[]
  intro?: string | null
  occupation?: string | null
  photo_album?: readonly string[]
  province?: string | null
}) {
  const checks = [
    Boolean(user.avatar),
    Boolean(user.birthday),
    Number(user.gender || 0) > 0,
    Boolean(user.province),
    Boolean(user.occupation),
    Boolean(user.intro),
    Boolean(user.interest_tags?.length),
    Boolean(user.photo_album?.length),
  ]
  return Math.round(checks.filter(Boolean).length / checks.length * 100)
}
